// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICheckDetailsUpdateDto
 */
export interface ICheckDetailsUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ICheckDetailsUpdateDto
     */
    vendor_id: number;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsUpdateDto
     */
    vendor_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsUpdateDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsUpdateDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsUpdateDto
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsUpdateDto
     */
    address_line_1: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsUpdateDto
     */
    address_line_2?: string;
}

/**
 * Check if a given object implements the ICheckDetailsUpdateDto interface.
 */
export function instanceOfICheckDetailsUpdateDto(value: object): value is ICheckDetailsUpdateDto {
    if (!('vendor_id' in value) || value['vendor_id'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('address_line_1' in value) || value['address_line_1'] === undefined) return false;
    return true;
}

export function ICheckDetailsUpdateDtoFromJSON(json: any): ICheckDetailsUpdateDto {
    return ICheckDetailsUpdateDtoFromJSONTyped(json, false);
}

export function ICheckDetailsUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICheckDetailsUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'vendor_id': json['vendor_id'],
        'vendor_name': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'address_line_1': json['address_line_1'],
        'address_line_2': json['address_line_2'] == null ? undefined : json['address_line_2'],
    };
}

export function ICheckDetailsUpdateDtoToJSON(json: any): ICheckDetailsUpdateDto {
    return ICheckDetailsUpdateDtoToJSONTyped(json, false);
}

export function ICheckDetailsUpdateDtoToJSONTyped(value?: ICheckDetailsUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'address_line_1': value['address_line_1'],
        'address_line_2': value['address_line_2'],
    };
}

